import {ENDPOINT_URL} from 'constants/index';

const headers = new Headers();
headers.append('Content-Type', 'application/json');

const authErrorMessage = {
	message: `Kunne ikke logge inn!`,
};

function IsValidJSONString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

export const authCallbackCreator = (
	key,
	regToken,
	method,
	changeIntent,
	adminId,
	resolve,
	reject
) => {
	const authCallback = (event) => {
		let data = event.data ? event.data : null;
		if (event.data && IsValidJSONString(event.data)) {
			data = JSON.parse(event.data);
		} else {
			return;
		}
		window.removeEventListener('message', authCallback);

		if (data.authError) {
			reject({message: 'There was an error logging you in'});
			return;
		}

		if (data && data.action === 'auth' && data.result === 'OK') {
			localStorage.setItem('authtoken', data.authToken);
			if (regToken && changeIntent === 'verify') {
				window.location.href = `/new-method/?&id=${regToken}&mtd=${method}`;
				resolve();
				return;
			} else if (changeIntent === 'feide2pointZero') {
				// the intent token should be stored in the constants file.
				window.location.href = `/my-subscription`;
				resolve();
				return;
			}

			window.location.href = `/my-tests`;
			resolve();
			return;
		}
		reject(authErrorMessage);
	};

	return authCallback;
};
export const initAuth = (
	provider,
	key,
	regToken,
	chosenMethod,
	changeIntent,
	adminId
) => {
	const payload = {
		provider,
		origin: 'backoffice',
	};
	if (key) {
		payload.key = key;
	}

	if (regToken && changeIntent) {
		payload.intent = changeIntent;
		payload.userRegId = regToken;
	}
	if (adminId) {
		payload.administratorId = adminId;
	}

	const route = provider === 'BankID' ? 'initAuthOidc' : 'initAuth';

	//  Use FORM instead of fetch for OIDC
	if (provider === 'BankID') {
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = `${ENDPOINT_URL}/${route}`;

		Object.entries(payload).forEach(([key, value]) => {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = key;
			input.value = value;
			form.appendChild(input);
		});

		document.body.appendChild(form);
		form.submit();

		return Promise.resolve();
	}

	const body = JSON.stringify(payload);

	return fetch(`${ENDPOINT_URL}/${route}`, {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers,
		body,
	}).then((response) => {
		if (response.ok) {
			return response.json();
		}
		return Promise.reject(response);
	});
};
